// extracted by mini-css-extract-plugin
export default {"faq":"faq___UTZPV","faq_content":"faq_content___y58jm","faq_column":"faq_column___T3TXc","faq_smiles":"faq_smiles___SY1a9","faq_lottie":"faq_lottie____0MGD"};